import appConstants from '@appConstants';
import MESSAGES from '../../../../../../appMessages';
export interface AccessorialItem {
  name: string;
  isChecked: boolean;
}

export interface DeliveryEditInfoWithSort {
  accessorials: AccessorialItem[];
  deliveryStatus?: string;
  sortAndSegregatePieces?: number | string | null;
}
export interface DeliverySortAndSegregateValidationParams {
  enableSortAndSegregatePieces?: boolean;
  editInfo: DeliveryEditInfoWithSort;
  value?: number | string | null;
}

export const isSortAndSegregateChecked = (
  accessorials: AccessorialItem[] | null | undefined,
  sortAndSegregateCode: string
): boolean => {
  if (!accessorials?.length) return false;
  return accessorials.find((ele) => ele.name === sortAndSegregateCode)?.isChecked ?? false;
};



export const getDeliverySortAndSegregateValidationError = ({
  enableSortAndSegregatePieces,
  editInfo,
  value,
}: DeliverySortAndSegregateValidationParams): string | null => {
  if (!enableSortAndSegregatePieces) return null;
  if (!isSortAndSegregateChecked(editInfo.accessorials, appConstants.ACCESSORIAL.SORT_AND_SEGREGATE)) {
    return null;
  }
  if (
    [appConstants.DELIVERY_CODE.RTN, appConstants.DELIVERY_CODE.SND].includes(
      editInfo.deliveryStatus ?? ''
    )
  ) {
    return null;
  }
  return Number(value) > 0 ? null : MESSAGES.PROCESS_DELIVERY.SORT_AND_SEGREGATE_PIECES_REQUIRED;
};
